<template>
  <section class='shipping-method' v-if='!preorder && can_calculate_shipping'>
    <h3>SHIPPING METHOD</h3>

    <!-- Canada shipping notice -->
    <!-- <div v-if='order.shipping_address.country === "Canada"' class="canada-shipping-notice" style="background-color: #dc3545; border: 2px solid #c82333; color: white; padding: 20px; margin-bottom: 25px; border-radius: 8px; font-size: 16px; font-weight: bold; text-align: center; box-shadow: 0 4px 8px rgba(220, 53, 69, 0.3);">
      <div style="font-size: 24px; margin-bottom: 8px;">⚠️ IMPORTANT NOTICE ⚠️</div>
      <div>Due to ongoing strikes affecting Canada Post and DHL, delivery timelines are currently uncertain.</div>
      <div style="margin-top: 8px; font-size: 15px;">Please place an order only if you’re comfortable with a potential delay in receiving your package.</div>
    </div> -->

    <div v-if='loading'>
      <div class="la-ball-pulse la-dark">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>

    <div class="available-shipping-methods" v-if='available_shipping_methods.length !== 0'>
      <label class='radio-label' v-bind:class='{disabled: all_disabled || shipping_method.disabled}' v-for="shipping_method in available_shipping_methods" :key="shipping_method.id" :data-id="shipping_method.id" :data-fulfiller="shipping_method.fulfiller">
        <span class='bold'>{{ estimated_delivery_text(shipping_method) }}</span>
        <input type='radio' name='shipping_method' :value='shipping_method' :disabled='all_disabled || shipping_method.disabled' v-model='order.shipping_method'>
        <span class='radio'></span>
        <div style='font-size: 14px'>{{shipping_method.name}} - ${{shipping_method.price_cents / 100}}</div>
        <div style='font-size: 13px; color: #A1A1AA;'>{{shipping_method.notes}}</div>
      </label>
    </div>

    <div class='error' v-if='!$v.shipping_method.required'>Shipping Method is required</div>

    <div class="alert alert-danger" v-if="this.backordered()" role="alert">
      <strong>Note:</strong> Your order contains items that are currently out of stock in our {{ this.fulfiller() === 'shipmonk' ? 'EU' : 'US' }} warehouse. We will ship your order as soon as our {{ this.fulfiller() === 'shipmonk' ? 'EU' : 'US' }} warehouse receives the out of stock items.
    </div>
  </section>
</template>

<script>
  import { is_military_address } from 'app/helpers/AddressHelpers'
import _ from 'lodash'
import debounce from 'lodash/debounce'
import filter from 'lodash/filter'
import includes from 'lodash/includes'

  export default {
    props: ['preorder', 'order', '$v', 'amazon_fulfillment_enabled'],
    data() {
      return {
        loading: true,
        all_disabled: true,
        shipping_methods: [],
        default_fulfillers: [],
      }
    },
    created() {
      this.debounced_update_shipping_methods = debounce(this.update_shipping_methods, 500)
    },
    mounted() {
      this.debounced_update_shipping_methods()
    },
    methods: {
      update_shipping_methods() {
        if (this.shipping_methods.length > 0) return // already fetched

        this.$set(this.order.errors, 'shipping_address', null)
        this.loading = true
        this.$http.get('/shipping_methods').then((response) => {
          this.loading = false
          this.$set(this, 'all_disabled', false)
          const json = response.body

          this.shipping_methods = json.shipping_methods

          this.default_fulfillers = json.default_fulfillers
          this.backordered_fulfillers = json.backordered_fulfillers

          this.order.shipping_methods = this.shipping_methods
          this.order.default_fulfillers = this.default_fulfillers

          if (this.order.shipping_method) {
            this.shipping_methods.forEach((shipping_method) => {
              if (shipping_method.id == this.order.shipping_method.id) {
                this.order.shipping_method = shipping_method
              }
            })
          }
        }, response => {
            this.loading = false
            this.$set(this, 'all_disabled', true)
            this.order.shipping_method = null
            let error_message = typeof response.body == 'object' ? response.body.error : 'Sorry, an error occurred while trying to update shipping estimates.'
            this.$set(this.order.errors, 'shipping_address', error_message)
        })
      },
      estimated_delivery_text(shipping_method) {
        if (this.backordered()) {
          return `Estimated delivery - 2 to 3 weeks`
        } else

        return `Estimated delivery by ${shipping_method.estimated_delivery}`
      },
      fulfiller() {
        return this.default_fulfillers[this.order.shipping_address.country] || 'north_of_you'
      },
      backordered() {
        return this.backordered_fulfillers && this.backordered_fulfillers.includes(this.fulfiller())
      },
      product_quantity() {
        let quantity = 0
        quantity += this.order.products.arsenal.quantity
        let extra_cables = this.order.products.arsenal.cables.length - this.order.products.arsenal.quantity
        if (extra_cables > 0) {
          quantity += extra_cables
        }
        quantity += this.order.products.arsenal_pro.quantity
        extra_cables = this.order.products.arsenal_pro.cables.length - this.order.products.arsenal_pro.quantity
        if (extra_cables > 0) {
          quantity += extra_cables
        }
        quantity += this.order.products.phone_mount.quantity
        quantity += this.order.products.battery.quantity
        quantity += this.order.products.micro_sd_card.quantity
        return quantity
      }
    },
    computed: {
      can_calculate_shipping () {
        return (this.order.shipping_address.country == 'United States of America' && this.order.shipping_address.state != '') || (this.order.shipping_address.country != '' && this.order.shipping_address.country != 'United States of America')
      },
      available_shipping_methods () {
        if (!this.shipping_methods || this.shipping_methods.length === 0) return []

        let shipping_methods = _.cloneDeep(this.shipping_methods) // clone objects in array so we can modify properties

        // Only shipping methods for this country
        shipping_methods = filter(shipping_methods, (shipping_method) => {
          return shipping_method.country === this.order.shipping_address.country
        })

        // Only shipping methods for the enabled fulfiller
        let enabled_fulfiller = this.fulfiller()
        shipping_methods = filter(shipping_methods, (shipping_method) => {
          return shipping_method.fulfiller === enabled_fulfiller
        })

        // Disable non-standard shipping methods for military addresses
        if (enabled_fulfiller == 'north_of_you' && is_military_address(this.order.shipping_address.state)) {
          shipping_methods.forEach((shipping_method) => {
            if (shipping_method.name === 'Standard Shipping') {
              shipping_method.notes = 'APO/FPO/DPO addresses may take up to 14 business days'
            } else {
              shipping_method.notes = `APO/FPO/DPO not eligible for ${shipping_method.name}`
              shipping_method.disabled = true
            }
          })
        }

        // Disable Express for Hawaii & Alaska
        if (this.order.shipping_address.state == 'Hawaii' || this.order.shipping_address.state == 'Alaska') {
          shipping_methods.forEach((shipping_method) => {
            if (shipping_method.name == 'Express Shipping') {
              shipping_method.disabled = true
              shipping_method.notes = `Express orders cannot be shipped to ${this.order.shipping_address.state}`
            }
          })
        }

        let valid_shipping_methods = filter(shipping_methods, (sm) => !sm.disabled)
        if (valid_shipping_methods.length == 1) {
          this.order.shipping_method = valid_shipping_methods[0]
        } else if (this.order.shipping_method && !includes(_.map(valid_shipping_methods, 'id'), this.order.shipping_method.id)) {
          this.order.shipping_method = null // clear shipping method since it's no longer a valid option
        }

        return shipping_methods
      },
    }
  }
</script>
